import PropTypes from 'prop-types';
import HighCharts from '../HighCharts';

import s from './MixedChartBlock.module.css';

const MixedChartBlock = ({
    title,
    displayLargeTitle,
    showTitleInToc,

    xAxisLabel,
    xAxisLabelFormattting,
    xAxisCategorySortingType,
    xAxisCategoryOrdering,

    yAxisLabel,
    yAxisMin,
    yAxisMax,
    yAxisTickInterval,

    decimalPlaces,

    aggregateDataByCategory,

    propertySeriesQueries,
    aggregateSeriesQueries,
    dynamicProperty,
    enableLineSymbols = true,
}) => {
    const plotOptions = {
        series: {
            marker: {
                enabled: enableLineSymbols,
            },
        },
    };

    return (
        <div className={s.Root}>
            <HighCharts
                chartType="line"
                isMixedChart={true}
                title={title}
                showTitleInToc={showTitleInToc}
                displayLargeTitle={displayLargeTitle}
                xAxisLabel={xAxisLabel}
                xAxisLabelFormattting={xAxisLabelFormattting}
                xAxisCategorySortingType={xAxisCategorySortingType}
                xAxisCategoryOrdering={xAxisCategoryOrdering}
                yAxisLabel={yAxisLabel}
                yAxisMin={yAxisMin}
                yAxisMax={yAxisMax}
                yAxisTickInterval={yAxisTickInterval}
                decimalPlaces={decimalPlaces}
                aggregateDataByCategory={aggregateDataByCategory}
                propertySeriesQueries={propertySeriesQueries}
                aggregateSeriesQueries={aggregateSeriesQueries}
                dynamicProperty={dynamicProperty}
                plotOptions={plotOptions}
            />
        </div>
    );
};

MixedChartBlock.propTypes = {
    title: PropTypes.string,
    displayLargeTitle: PropTypes.bool,
    showTitleInToc: PropTypes.bool,

    xAxisLabel: PropTypes.string,
    xAxisLabelFormattting: PropTypes.string,
    xAxisCategorySortingType: PropTypes.string,
    xAxisCategoryOrdering: PropTypes.string,

    yAxisLabel: PropTypes.string,
    yAxisMin: PropTypes.number,
    yAxisMax: PropTypes.number,
    yAxisTickInterval: PropTypes.number,

    decimalPlaces: PropTypes.number,

    aggregateDataByCategory: PropTypes.bool,

    propertySeriesQueries: PropTypes.array,
    aggregateSeriesQueries: PropTypes.array,

    dynamicProperty: PropTypes.string,
    enableLineSymbols: PropTypes.bool,
};

export default MixedChartBlock;
